import { computed, makeObservable } from 'mobx';
import {observer} from 'mobx-react';
import React from 'react';
import {X9Content, X9ContentSnapshot} from '../../../../../../domain';
import {X9ContentStateStore} from '../../../common/X9ContentStateStore';
import {McqModel} from '../../models';
import {StudentMultiSelectMcq} from './StudentMultiSelectMcq';
import {StudentSingleSelectMcq} from './StudentSingleSelectMcq';

interface Props {
  x9: X9Content | X9ContentSnapshot,
  store: X9ContentStateStore,
  lessonType?: string
}

@observer
export class StudentMcq extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    makeObservable(this);
  }

  @computed
  get model(): McqModel {
    return JSON.parse(this.props.x9.Contents) as McqModel;
  }

  render() {
    const props = this.props;
    const model = this.model;
    const behavior = model.behavior;
    const id = props.x9.Id;

    if (behavior === 'single-select')
      return (
        <StudentSingleSelectMcq id={id}
                                model={model}
                                store={props.store}
                                lessonType={props.lessonType}/>);

    if (behavior === 'multi-select')
      return (
        <StudentMultiSelectMcq id={id}
                               model={model}
                               store={props.store}
                               lessonType={props.lessonType}/>);

    return null;
  }
}
